/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversations_Show_MoreInputs */



/**
* | output |
* | --- |
* | "Show more" |
*
* @param {Conversations_Show_MoreInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const conversations_show_more = /** @type {((inputs?: Conversations_Show_MoreInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversations_Show_MoreInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Toon meer")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher plus")
	return /** @type {LocalizedString} */ ("Show more")
});